export const TransportMenu = {
  routes: [
    {
      name: 'vehicles',
      displayName: 'menu.vehicles',
      subject_class: 'Vehicles'
    },
    {
      name: 'vehicle_types',
      displayName: 'menu.vehicle_types',
      subject_class: 'VehicleTypes'
    },
    {
      name: 'bay_types',
      displayName: 'menu.bay_types',
      subject_class: 'BayTypes'
    },
  ]
} 

        